import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/app/apps/play-portal/src/app/client-providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/play-portal/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/app/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/app/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/app/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
